// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"a754a2fc","754":"0e98472d","989":"9d12594f"}[chunkId] + ".chunk.js";
};